// extracted by mini-css-extract-plugin
export default {"dbsidebar":"DBSidebar_dbsidebar__QOGnB"};